import { useMapEvents } from 'react-leaflet';

export const MapClickHandler = ({
  onLocationSelect,
}: {
  onLocationSelect: (lat: number, lng: number) => void;
}) => {
  useMapEvents({
    click: e => onLocationSelect(e.latlng.lat, e.latlng.lng),
  });
  return null;
};
